import React from 'react';
import './style.scss';

export const Owner = ({ name, date, dp = 'https://i.pinimg.com/originals/f1/f2/15/f1f21522c94ed0d3ae32ad9a69d7de4d.jpg' }) => (
  <div className={'owner-container '}>
    <img src={dp} className={'dp'} />
    <div className={'info'}>
      <div className={'name'}>{name}</div>
      <p className={'date'}>{date}</p>
    </div>
  </div>
);
